import { User } from 'lucide-react';
import { getPatientOverviewOptions, type OrderViewModel } from '@generated';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useSuspenseQuery } from '@tanstack/react-query';

export function OrderPatientDetails({ order }: { order: OrderViewModel }) {
	const { data: patientOverview } = useSuspenseQuery(getPatientOverviewOptions(order.stayId));
	return (
		<Section header={<SectionTitle title="Patient Information" TitleIcon={User} />}>
			<div className="grid grid-cols-3 gap-6">
				<div>
					<label className="block text-sm font-medium text-gray-500">Name</label>
					<p className="text-gray-900">
						{patientOverview.firstName} {patientOverview.lastName}
					</p>
				</div>
				<div>
					<label className="block text-sm font-medium text-gray-500">Date of Birth</label>
					<p className="text-gray-900">{patientOverview.dateOfBirth.toLocaleDateString()}</p>
				</div>
				<div>
					<label className="block text-sm font-medium text-gray-500">Sex</label>
					<p className="text-gray-900">{patientOverview.genderLabel}</p>
				</div>
				<div className="col-span-3">
					<label className="block text-sm font-medium text-gray-500">Address</label>
					<p className="text-gray-900">{`${patientOverview.visitAddressAddressOne}, ${patientOverview.visitAddressCity}, ${patientOverview.visitAddressState} ${patientOverview.visitAddressZipCode}`}</p>
				</div>
			</div>
		</Section>
	);
}
